/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: contents;
}

.qds-table {
  border-collapse: collapse;
  border-spacing: 0;
  box-sizing: border-box;
}
